import {createStore, applyMiddleware, compose} from 'redux';
import rootReducer from '../reducers';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';


export default function configureStore(preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
      composeWithDevTools(applyMiddleware(thunk, reduxImmutableStateInvariant()))
  );
}
